<div class="flex-shrink-0 w-full pt-4" [ngClass]="{ 'max-lg:!hidden': !filtersVisible() }">
  @if (filtersHasError()) {
    <div class="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2.5 mb-3">
      <i class="pi pi-times-circle text-red-600 mt-0.5"></i>
      <span class="flex-1 text-sm text-red-900">Could not load filters.</span>
      <p-button
        label="Retry"
        icon="pi pi-refresh"
        size="small"
        severity="danger"
        [text]="true"
        (onClick)="retryFilters()"
      />
    </div>
  } @else if (!filtersLoading() && !hasAnyOptions()) {
    <p-message class="mb-3" severity="warn" size="small" icon="pi pi-info-circle">
      This home has no options set up for its model and elevation, so there is nothing to filter. Options have to be
      assigned to the model and elevation first.
    </p-message>
  }
  <div class="grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 gap-5 w-full items-end">
    <div class="flex flex-col flex-shrink-0">
      <p-floatlabel variant="on">
        <generic-dropdown
          class="w-full"
          placeholder=""
          [items]="categories()"
          [allowSearch]="true"
          [required]="true"
          [disabled]="!hasAnyOptions()"
          [loading]="filtersLoading()"
          [clearable]="false"
          [ngModel]="selectedCategoryId()"
          (ngModelChange)="selectedCategoryId.set($event); selectedSubcategoryId.set(null)"
          [optionAll]="false"
          [optionAllLabel]="'All Categories'"
          appendTo="body"
        />
        <label>Category <span class="text-red-500">*</span></label>
      </p-floatlabel>
    </div>
    <div class="flex flex-col flex-shrink-0">
      <p-floatlabel variant="on">
        <generic-dropdown
          class="w-full"
          placeholder=""
          [items]="subcategories()"
          [allowSearch]="true"
          [clearable]="false"
          [disabled]="!hasAnyOptions()"
          [loading]="filtersLoading()"
          [ngModel]="selectedSubcategoryId()"
          (ngModelChange)="selectedSubcategoryId.set($event)"
          [optionAll]="true"
          [optionAllLabel]="'All Subcategories'"
        />
        <label>Subcategory</label>
      </p-floatlabel>
    </div>
    <div class="flex flex-col flex-shrink-0">
      <p-floatlabel variant="on">
        <generic-dropdown
          class="w-full"
          placeholder=""
          [items]="rooms()"
          [allowSearch]="true"
          [clearable]="false"
          [disabled]="!hasAnyOptions()"
          [loading]="filtersLoading()"
          [ngModel]="selectedRoomId()"
          (ngModelChange)="selectedRoomId.set($event)"
          [optionAll]="true"
          [optionAllLabel]="'All Rooms'"
        />
        <label>Rooms</label>
      </p-floatlabel>
    </div>
    @if (canApplyCutoff()) {
      <div class="flex flex-col flex-shrink-0">
        <p-floatlabel variant="on">
          <p-select
            [ngModel]="selectedApplyCutoff()"
            (ngModelChange)="selectedApplyCutoff.set($event)"
            [options]="cutoffOptions"
            optionLabel="label"
            optionValue="value"
            [showClear]="false"
            styleClass="w-full"
          />
          <label>Apply Cutoff</label>
        </p-floatlabel>
      </div>
    }
  </div>
</div>

<div class="flex flex-col flex-1 min-h-0 rounded-[16px] bg-elevation-one overflow-hidden">
  @if (hasCategorySelected() && (products().length > 0 || searchTerm().length > 0)) {
    <div class="flex-shrink-0 w-full px-4 pt-4">
      <div class="flex items-center justify-between gap-3 w-full">
        <div class="inline-flex items-center gap-1 rounded-full bg-primary-100 p-1">
          <button
            type="button"
            class="inline-flex items-center justify-center px-3 h-[25px] rounded-full border-0 cursor-pointer transition-all duration-150"
            [class.bg-primary-500]="viewMode() === 'grid'"
            [class.text-white]="viewMode() === 'grid'"
            [class.bg-transparent]="viewMode() !== 'grid'"
            [class.text-surface-600]="viewMode() !== 'grid'"
            pTooltip="Grid view"
            tooltipPosition="top"
            (click)="viewMode.set('grid')"
          >
            <i class="pi pi-th-large text-sm"></i>
          </button>
          <button
            type="button"
            class="inline-flex items-center justify-center px-3 h-[25px] rounded-full border-0 cursor-pointer transition-all duration-150"
            [class.bg-primary-500]="viewMode() === 'list'"
            [class.text-white]="viewMode() === 'list'"
            [class.bg-transparent]="viewMode() !== 'list'"
            [class.text-surface-600]="viewMode() !== 'list'"
            pTooltip="List view"
            tooltipPosition="top"
            (click)="viewMode.set('list')"
          >
            <i class="pi pi-list text-sm"></i>
          </button>
        </div>

        <div class="flex items-center gap-2">
          <div
            class="flex items-center h-8 rounded-full overflow-hidden max-w-[60vw] transition-all duration-300 ease-in-out"
            [class.w-8]="!searchExpanded()"
            [class.w-96]="searchExpanded()"
            [class.bg-white]="searchExpanded()"
            [class.border]="searchExpanded()"
            [class.border-solid]="searchExpanded()"
            [class.border-surface-300]="searchExpanded()"
            [class.bg-transparent]="!searchExpanded()"
            [class.flex-row-reverse]="searchExpanded()"
          >
            <p-button
              icon="pi pi-search"
              size="small"
              severity="secondary"
              [outlined]="true"
              [styleClass]="
                searchExpanded()
                  ? '!h-8 !px-3 shrink-0 !border-0 !bg-transparent !text-primary'
                  : '!h-8 !px-3 shrink-0 !text-primary !bg-transparent !border-[#E2E8F0] hover:!bg-[#F1F5F9]'
              "
              pTooltip="Search"
              tooltipPosition="top"
              ariaLabel="Search"
              (onClick)="toggleSearch(searchInput)"
            />
            <input
              #searchInput
              type="text"
              class="flex-1 min-w-0 h-full border-0 outline-none bg-transparent text-sm pl-3 pr-3"
              placeholder="Search Options"
              [value]="searchTerm()"
              (keyup)="onSearchKeyup($event)"
              (blur)="onSearchBlur()"
            />
          </div>
          @if (sortApplied()) {
            <p-button
              icon="pi pi-sort-alt"
              [label]="'Sorted by ' + sortLabel()"
              size="small"
              severity="primary"
              [outlined]="true"
              (onClick)="sortMenu.toggle($event)"
            />
          } @else {
            <p-button
              icon="pi pi-sort-alt"
              size="small"
              severity="secondary"
              [outlined]="true"
              [styleClass]="
                '!h-8 !px-3 !border-[#E2E8F0] hover:!bg-[#F1F5F9]' + (sortMenuOpen() ? ' !bg-[#F1F5F9]' : '')
              "
              pTooltip="Sort by"
              tooltipPosition="top"
              ariaLabel="Sort by"
              (onClick)="sortMenu.toggle($event)"
            />
          }
          <p-menu
            #sortMenu
            styleClass="dsm-sort-menu"
            (onShow)="sortMenuOpen.set(true)"
            (onHide)="sortMenuOpen.set(false)"
            [model]="sortMenuItems()"
            [popup]="true"
            appendTo="body"
          />
        </div>
      </div>
    </div>
  }

  <div class="flex flex-1 min-h-0 overflow-hidden gap-4">
    <div class="flex flex-col flex-1 min-w-0">
      <div class="flex-1 min-h-0 overflow-y-auto relative p-4">
        @if (isLoadingOptions()) {
          <div class="flex flex-col items-center justify-center h-full gap-3 text-surface-400 p-8 text-center">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            <p class="text-body-sm m-0">Loading options...</p>
          </div>
        } @else if (optionsLoadError()) {
          <div class="flex flex-col items-center justify-center h-full gap-3 p-8 text-center">
            <i class="pi pi-times-circle text-red-600" style="font-size: 2rem"></i>
            <p class="text-body-sm-500 text-surface-700 m-0">Could not load options.</p>
            <p class="text-body-sm text-surface-500 m-0">
              Something went wrong while loading options for this model and elevation.
            </p>
            <p-button label="Retry" icon="pi pi-refresh" size="small" [outlined]="true" (onClick)="refreshOptions()" />
          </div>
        } @else if (!hasCategorySelected()) {
          <div
            class="flex flex-col items-center justify-start h-full gap-3 text-[color:var(--text-muted-color,#64748B)] px-8 pb-8 pt-2 text-center"
          >
            <i class="bi bi-search" style="font-size: 3rem"></i>
            <p class="text-base m-0">Select a category to start exploring options.</p>
          </div>
        } @else if (!products().length) {
          <div class="flex flex-col items-center justify-center h-full gap-3 text-surface-400 p-8 text-center">
            <i class="bi bi-info-circle" style="font-size: 3rem"></i>
            <p class="text-body-sm m-0">No options available for the selected model and elevation.</p>
          </div>
        } @else {
          <div
            class="grid gap-4 pb-2"
            [ngClass]="
              viewMode() === 'list'
                ? 'grid-cols-1'
                : sidebarPinned()
                  ? 'xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2'
                  : 'xl:grid-cols-6 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2'
            "
          >
            @for (product of products(); track product.productId) {
              <div
                class="rounded-[16px] cursor-pointer border p-4"
                [ngClass]="[
                  isProductSelected(product) ? 'border-emerald-200 bg-emerald-50 ' : 'border-surface-200 bg-white',
                  viewMode() === 'grid' ? 'flex flex-col gap-4 h-full' : 'flex items-center gap-3'
                ]"
              >
                <div
                  class="relative overflow-hidden rounded-[16px] bg-surface-100 flex-shrink-0"
                  [ngClass]="viewMode() === 'grid' ? 'h-[260px]' : 'w-16 h-16 rounded-[12px]'"
                >
                  @if (hasProductImages(product)) {
                    <lib-image-preview
                      [images]="getProductPreviewImages(product)"
                      [title]="product.description || product.code"
                      [subheadingTemplate]="productPreviewSubheading"
                    >
                      <ng-template #productPreviewSubheading>
                        <div class="flex flex-wrap gap-x-4 gap-y-0.5 text-body-sm text-surface-500">
                          @if (product.category) {
                            <p-tag [value]="product.category" severity="info" size="small" />
                          }
                          @if (product.subcategory) {
                            <p-tag [value]="product.subcategory" severity="secondary" size="small" />
                          }
                        </div>
                      </ng-template>
                      <img
                        [src]="getProductImageUrl(product)"
                        alt="Product image"
                        class="w-full h-full object-cover transition-transform duration-300"
                        [ngClass]="viewMode() === 'grid' ? 'hover:scale-105' : ''"
                        pTooltip="Click to view all images"
                        tooltipPosition="top"
                      />
                    </lib-image-preview>
                  } @else {
                    <img
                      [src]="defaultProductImageUrl"
                      alt="No product image"
                      class="w-full h-full object-contain"
                      [ngClass]="viewMode() === 'grid' ? 'p-4' : 'p-2'"
                    />
                  }

                  @if (viewMode() === 'grid') {
                    <ng-container
                      [ngTemplateOutlet]="selectedBadgeTpl"
                      [ngTemplateOutletContext]="{
                        wrapperClass: 'absolute top-2.5 right-2.5 px-2.5 py-1'
                      }"
                    />
                    @if (product.type || product.selectionRequired || product.isKit) {
                      <div class="absolute bottom-2 left-2 flex items-center gap-1 flex-wrap">
                        <ng-container [ngTemplateOutlet]="tagsTpl" />
                      </div>
                    }
                  }
                </div>

                <div class="flex flex-1 min-w-0 gap-4" [ngClass]="viewMode() === 'grid' ? 'flex-col' : 'items-center'">
                  <div class="flex flex-col flex-1 min-w-0">
                    <div class="flex items-center gap-2 flex-wrap mb-0.5">
                      <span
                        class="text-surface-700"
                        [ngClass]="viewMode() === 'grid' ? 'text-body-lg-500' : 'text-body-md-600'"
                        >{{ product.description }}</span
                      >
                      @if (viewMode() === 'list') {
                        <ng-container
                          [ngTemplateOutlet]="selectedBadgeTpl"
                          [ngTemplateOutletContext]="{ wrapperClass: 'px-2 py-0.5 shrink-0' }"
                        />
                        <ng-container [ngTemplateOutlet]="tagsTpl" />
                      }
                    </div>

                    <div class="flex flex-wrap gap-1 text-body-sm text-surface-500">
                      @if (product.category) {
                        <span>{{ product.category }}</span>
                      }
                      @if (product.category && product.subcategory) {
                        /
                      }
                      @if (product.subcategory) {
                        <span>{{ product.subcategory }}</span>
                      }
                    </div>

                    <p
                      class="text-body-sm text-slate-700 m-0 mt-4"
                      [ngClass]="viewMode() === 'grid' ? 'line-clamp-2 flex-1' : 'truncate'"
                    >
                      {{ product.code }}
                    </p>
                  </div>

                  <div
                    class="flex"
                    [ngClass]="viewMode() === 'grid' ? 'flex-col gap-3' : 'items-center gap-3 shrink-0'"
                  >
                    <div class="flex items-baseline gap-1">
                      <span
                        class="text-emerald-700"
                        [ngClass]="viewMode() === 'grid' ? 'text-body-lg-600 flex-shrink-0' : 'text-body-md-600'"
                        >{{ product.unitPrice | currencyFormat }}</span
                      >
                      <span class="text-body-sm text-slate-500" [ngClass]="viewMode() === 'grid' ? 'flex-shrink-0' : ''"
                        >/ {{ product.uom }}</span
                      >
                    </div>
                    <p-button
                      icon="pi pi-plus"
                      [label]="isPackageSource() && isProductSelected(product) ? 'Added' : 'Add'"
                      size="small"
                      [outlined]="viewMode() === 'grid'"
                      [styleClass]="
                        viewMode() === 'grid'
                          ? '!w-full !h-10 !justify-center !text-base'
                          : '!bg-primary-500 !border-primary-500'
                      "
                      [disabled]="isPackageSource() && isProductSelected(product)"
                      (onClick)="pickProduct(product); $event.stopPropagation()"
                    />
                  </div>
                </div>

                <ng-template #selectedBadgeTpl let-wrapperClass="wrapperClass">
                  @if (isProductNewlySelected(product)) {
                    @let selectedCount = getProductSelectedCount(product);
                    <span
                      class="bg-orange-500 text-white text-body-xs-700 rounded-full leading-none uppercase"
                      [ngClass]="wrapperClass"
                    >
                      {{ selectedCount > 1 ? 'Selected (x' + selectedCount + ')' : 'Selected' }}
                    </span>
                  }
                </ng-template>

                <ng-template #tagsTpl>
                  @if (product.isKit) {
                    <p-tag value="KIT" size="small" severity="info" />
                  }
                  @if (product.type) {
                    <p-tag [value]="product.type" size="small" severity="success" />
                  }
                  @if (product.selectionRequired) {
                    <p-tag value="ATTRIBUTE REQUIRED" size="small" severity="warn" />
                  }
                </ng-template>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <ng-content select="[optionsSelectedPanel]"></ng-content>
  </div>
</div>
